var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/jsx-props-no-spreading */
/* disable for HTMLInputElement props passthrough to generic input */
import React, { useState, useMemo, useRef, useEffect, } from 'react';
import styled, { css } from 'styled-components';
import uniqueId from 'lodash.uniqueid';
import { useIntl, FormattedMessage } from 'react-intl';
import formTheme from '../../theme';
import { ComponentThemeProvider } from '../../../ThemeProvider';
import Label from '../../Label';
import ErrorMessage from '../ErrorMessage';
import useDebounce from '../../../hooks/useDebounce';
import InputHint from '../InputHint';
import { Grid, Cell } from '../../../Grid';
var getLevel = function (error) { return (error ? 'error' : 'normal'); };
export var Input = styled.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  input[type='text']& {\n    /*\n    In the mobile fragments these styles are overwritten by Intershop with selector input[type='text']\n    We need this here to come over that.\n  */\n  ", "\n  ", "\n    border-radius: ", ";\n    padding: ", ";\n  }\n  appearance: none;\n  background-color: ", ";\n  ", ";\n  border: 0 none;\n  border-radius: ", ";\n  ", "\n  color: ", ";\n  flex: 1;\n  min-width: 0;\n  outline: 0;\n  overflow: hidden;\n  padding: ", ";\n  text-overflow: ellipsis;\n  width: 100%;\n  font-size: ", ";\n  &:focus,\n  &:active {\n    ", "\n  }\n  &:focus + .button-content,\n  &:active + .button-content {\n    ", "\n    border-left-width: 0;\n  }\n  &:disabled {\n    box-shadow: inset 0 0 0 1px ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n  &:disabled + .button-content {\n    border: 1px solid ", ";\n    border-left-width: 0;\n  }\n  ", ";\n"], ["\n  input[type='text']& {\n    /*\n    In the mobile fragments these styles are overwritten by Intershop with selector input[type='text']\n    We need this here to come over that.\n  */\n  ",
    "\n  ", "\n    border-radius: ",
    ";\n    padding: ", ";\n  }\n  appearance: none;\n  background-color: ",
    ";\n  ",
    ";\n  border: 0 none;\n  border-radius: ",
    ";\n  ", "\n  color: ", ";\n  flex: 1;\n  min-width: 0;\n  outline: 0;\n  overflow: hidden;\n  padding: ", ";\n  text-overflow: ellipsis;\n  width: 100%;\n  font-size: ", ";\n  &:focus,\n  &:active {\n    ",
    "\n  }\n  &:focus + .button-content,\n  &:active + .button-content {\n    ",
    "\n    border-left-width: 0;\n  }\n  &:disabled {\n    box-shadow: inset 0 0 0 1px ",
    ";\n    background-color: ", ";\n    color: ", ";\n  }\n  &:disabled + .button-content {\n    border: 1px solid ",
    ";\n    border-left-width: 0;\n  }\n  ",
    ";\n"])), function (_a) {
    var component = _a.theme.component, error = _a.error;
    return error && "box-shadow: inset 0 0 0 2px " + component.form.borderColor[getLevel(error)] + ";";
}, function (_a) {
    var hasButton = _a.hasButton;
    return hasButton && 'border-right-width: 0;';
}, function (_a) {
    var component = _a.theme.component, hasButton = _a.hasButton;
    return !hasButton
        ? component.form.borderRadius
        : component.form.borderRadius + " 0 0 " + component.form.borderRadius + ";";
}, function (_a) {
    var component = _a.theme.component;
    return component.form.input.padding;
}, function (_a) {
    var error = _a.error, component = _a.theme.component;
    return component.form.backgroundColor[getLevel(error)];
}, function (_a) {
    var component = _a.theme.component, error = _a.error, isFilled = _a.isFilled;
    return "box-shadow: inset 0 0 0 " + (error ? '2px' : '1px') + " " + (isFilled && !error
        ? component.form.borderColor.normal
        : component.form.borderColor[getLevel(error)]) + ";";
}, function (_a) {
    var component = _a.theme.component, hasButton = _a.hasButton;
    return !hasButton
        ? component.form.borderRadius
        : component.form.borderRadius + " 0 0 " + component.form.borderRadius;
}, function (_a) {
    var hasButton = _a.hasButton;
    return hasButton && 'border-right-width: 0;';
}, function (_a) {
    var component = _a.theme.component;
    return component.form.textColor.normal;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.input.padding;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.fontSize.small;
}, function (_a) {
    var component = _a.theme.component, error = _a.error;
    return error
        ? "box-shadow: inset 0 0 0 2px " + component.form.borderColor[getLevel(error)] + ";"
        : "box-shadow: inset 0 0 0 1px " + component.form.borderColor.active + ";";
}, function (_a) {
    var component = _a.theme.component, error = _a.error;
    return error
        ? "border: 2px solid " + component.form.borderColor[getLevel(error)] + ";"
        : "border: 1px solid " + component.form.borderColor.active + ";";
}, function (_a) {
    var component = _a.theme.component;
    return component.form.borderColor.disabled;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.backgroundColor.disabled;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.textColor.disabled;
}, function (_a) {
    var component = _a.theme.component, error = _a.error;
    return error ? component.form.borderColor[getLevel(error)] : component.form.borderColor.active;
}, function (_a) {
    var type = _a.type;
    /**
     * Removes the styling of input[type=number]
     */
    return (type === 'number' || type === 'text' || !type) && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      /* Chrome, Safari number spinner */\n      &::-webkit-inner-spin-button,\n      &::-webkit-outer-spin-button {\n        margin: 0;\n        -webkit-appearance: none;\n      }\n\n      /* Firefox number spinner */\n      -moz-appearance: textfield;\n\n      /* IE11, Edge clear icon */\n      &::-ms-clear {\n        display: none;\n      }\n    "], ["\n      /* Chrome, Safari number spinner */\n      &::-webkit-inner-spin-button,\n      &::-webkit-outer-spin-button {\n        margin: 0;\n        -webkit-appearance: none;\n      }\n\n      /* Firefox number spinner */\n      -moz-appearance: textfield;\n\n      /* IE11, Edge clear icon */\n      &::-ms-clear {\n        display: none;\n      }\n    "])));
});
export var InputWrapper = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  display: inline-flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  width: 100%;\n"], ["\n  position: relative;\n  display: inline-flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  width: 100%;\n"])));
/**
 * This fakes a "the button is inside the input" look by adapting the styling from the input
 * The left border and the left border-radius settings are disabled to make it "blend in" with the input
 */
export var ButtonContentWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: inline-block;\n  position: relative;\n  left: -2px;\n  border: ", ";\n  border-left-width: 0;\n  border-top-right-radius: ", ";\n  border-bottom-right-radius: ", ";\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: ", ";\n"], ["\n  display: inline-block;\n  position: relative;\n  left: -2px;\n  border: ",
    ";\n  border-left-width: 0;\n  border-top-right-radius: ", ";\n  border-bottom-right-radius: ", ";\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: ",
    ";\n"])), function (_a) {
    var error = _a.error, component = _a.theme.component;
    return error
        ? "2px solid " + component.form.borderColor[getLevel(error)] + ";"
        : "1px solid " + component.form.borderColor.normal + ";";
}, function (_a) {
    var component = _a.theme.component;
    return component.form.borderRadius;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.borderRadius;
}, function (_a) {
    var error = _a.error, component = _a.theme.component;
    return component.form.backgroundColor[getLevel(error)];
});
var PasswordLengthWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  text-align: right;\n"], ["\n  text-align: right;\n"])));
var PasswordLengthInner = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: ", ";\n  color: ", ";\n"], ["\n  font-size: ", ";\n  color: ",
    ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.form.fontSize.small;
}, function (_a) {
    var component = _a.theme.component, isValid = _a.isValid;
    return isValid ? component.form.lengthCheck.validColor : component.form.lengthCheck.color;
});
export var PasswordLength = function (_a) {
    var lengthMinMax = _a.lengthMinMax, length = _a.length;
    var isValid = typeof lengthMinMax === 'undefined'
        ? false
        : length >= lengthMinMax[0] && length <= lengthMinMax[1];
    return (React.createElement(PasswordLengthWrapper, null,
        React.createElement(PasswordLengthInner, { isValid: isValid },
            React.createElement(FormattedMessage, { id: "input.password.lengthdisplay", defaultMessage: "{length} characters", values: { length: length } }))));
};
export var BasicInput = function (_a) {
    var buttonContent = _a.buttonContent, error = _a.error, id = _a.id, inputRef = _a.inputRef, isValid = _a.isValid, label = _a.label, _b = _a.type, type = _b === void 0 ? 'text' : _b, validationRules = _a.validationRules, value = _a.value, defaultValue = _a.defaultValue, onValid = _a.onValid, onError = _a.onError, onChange = _a.onChange, onErrorTransmitMessage = _a.onErrorTransmitMessage, inputHint = _a.inputHint, disabled = _a.disabled, displayLength = _a.displayLength, lengthMinMax = _a.lengthMinMax, props = __rest(_a, ["buttonContent", "error", "id", "inputRef", "isValid", "label", "type", "validationRules", "value", "defaultValue", "onValid", "onError", "onChange", "onErrorTransmitMessage", "inputHint", "disabled", "displayLength", "lengthMinMax"]);
    var _c = useState(false), hasFocus = _c[0], setHasFocus = _c[1];
    var _d = useState(isValid), validState = _d[0], setValidState = _d[1];
    var _e = useState(error || null), errorState = _e[0], setErrorState = _e[1];
    var _f = useState(value || defaultValue || ''), valueState = _f[0], setValueState = _f[1];
    var debouncedValue = useDebounce(valueState, 1000);
    var intl = useIntl();
    var length = valueState.length;
    var validateField = function () {
        if (validationRules != null) {
            for (var i = 0; i < validationRules.length; i += 1) {
                var validator = validationRules[i];
                if (validator.required && !valueState) {
                    setErrorState(intl.formatMessage(validator.error));
                    setValidState(false);
                    return;
                }
                if (validator.regEx) {
                    if (valueState && !validator.regEx.test(debouncedValue)) {
                        setErrorState(intl.formatMessage(validator.error));
                        setValidState(false);
                        return;
                    }
                }
            }
        }
        setErrorState(null);
        setValidState(true);
    };
    var firstUpdate = useRef(true);
    useEffect(function () {
        if (firstUpdate.current) {
            // Don't show fields invalid on first render
            firstUpdate.current = false;
            return;
        }
        if (validationRules) {
            validateField();
        }
        else {
            setValidState(true);
        }
    }, [debouncedValue]);
    useEffect(function () {
        if (validState && onValid) {
            onValid();
        }
        else if (!validState) {
            if (onError) {
                onError();
            }
            if (onErrorTransmitMessage) {
                onErrorTransmitMessage(errorState);
            }
        }
    }, [validState, errorState]);
    var hasButton = !!buttonContent;
    var componentId = useMemo(function () {
        return !id ? uniqueId() : id;
    }, [id]);
    return (React.createElement(ComponentThemeProvider, { theme: formTheme },
        React.createElement(React.Fragment, null,
            (label || displayLength) && (React.createElement(Grid, { cellsPerRow: [2] },
                React.createElement(Cell, null, label && React.createElement(Label, { htmlFor: componentId }, label)),
                React.createElement(Cell, null, displayLength && React.createElement(PasswordLength, { lengthMinMax: lengthMinMax, length: length })))),
            React.createElement(InputWrapper, { focus: hasFocus },
                React.createElement(Input, __assign({ "data-testid": "input", error: errorState != null || error != null, hasButton: hasButton, id: componentId, onBlur: function () { return setHasFocus(false); }, onFocus: function () { return setHasFocus(true); }, ref: inputRef, type: type, value: value, defaultValue: defaultValue, isFilled: length > 0, disabled: disabled, onChange: function (event) {
                        setValueState(event.target.value);
                        if (onChange) {
                            onChange(event);
                        }
                    } }, props)),
                hasButton && (React.createElement(ButtonContentWrapper, { className: "button-content", error: errorState != null || error != null }, buttonContent))),
            !onErrorTransmitMessage && (errorState || error) && (React.createElement(ErrorMessage, { error: errorState || error })),
            inputHint && !onErrorTransmitMessage && !(errorState || error) && (React.createElement(InputHint, { message: inputHint, disabled: disabled })))));
};
export default BasicInput;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.js.map